import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserApiService } from 'src/app/services/api/user-api.service';

@Component({
  selector: 'app-coupon-list-modal',
  templateUrl: './coupon-list-modal.component.html',
  styleUrls: ['./coupon-list-modal.component.scss'],
})
export class CouponListModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<CouponListModalComponent>,
    private api: UserApiService
  ) {}

  close() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.findAffiliateCode();
  }

  code: any[] = [];
  loading = false;
  async findAffiliateCode() {
    try {
      this.loading = true;
      const r = await this.api.findAffiliateCode();
      this.code = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
